import { Component, ViewChild } from '@angular/core';
import { Chart, registerables, } from 'chart.js';
import * as  Utils from '../../assets/Utils';
import { DashboardService } from './service/dashboard.service';
import { LoadingController, IonSelect } from '@ionic/angular';
import { Title } from "@angular/platform-browser";

@Component({
	selector: 'app-launchpad',
	templateUrl: './dashboard.page.html',
	styleUrls: ['./dashboard.page.scss']
})

export class DashboardPage {

	@ViewChild('selectElement') selectElement: IonSelect;
	currentCoin = undefined;

	coins = [
		{
			id: 1,
			name: 'Hsuite',
			value: '0.0.786931'
		},
		{
			id: 2,
			name: 'Shibar',
			value: '0.0.751086'
		},
	];

	selectedOption = this.coins[0];
  
	ngAfterViewInit() {
	  this.selectElement.value = this.selectedOption;
	}

	[x: string]: any;
	public chart: any;
	public piechart: any;
	public gaugechart: any;
	private dataBar: any;
	private dataPie: any;
	public updated = "";
	spinner = true;
	balances: any;
	clickBarChartLabel: any;
	clickBarChartValue: any;
	clickBarChartAccount: any;
	clickBarChartBalance: any;
	paginationPage: number = 1;
	paginationCount: number = 0;
	tableSize: number = 10;
	isAscending = true;
	gaugeChartText: any;
	gradientBg1: any;
	coinName: any = 'Hsuite';

	constructor(private service: DashboardService, private titleService: Title) {
		Chart.register(...registerables);
		this.titleService.setTitle("DecentralRealty - Dashboard");
	}

	private initializedChartData(dataAll: any) {
		
		//console.log('dataAll - Hsuite: ', dataAll);
		
		let var_100 = dataAll.filter((obj: any) => (obj.balance / 10000) < 101).length;
		let var_100K = dataAll.filter((obj: any) => (obj.balance / 10000) > 100 && (obj.balance / 10000) < 100001).length;
		let var_1M = dataAll.filter((obj: any) => (obj.balance / 10000) > 100000 && (obj.balance / 10000) < 1000001).length;
		let var_10M = dataAll.filter((obj: any) => (obj.balance / 10000) > 1000000 && (obj.balance / 10000) < 10000001).length;
		let var_100M = dataAll.filter((obj: any) => (obj.balance / 10000) > 10000000 && (obj.balance / 10000) < 100000001).length;
		let var_100M_Plus = dataAll.filter((obj: any) => (obj.balance / 10000) > 100000000).length;
		let labels = ['0 - 100', '101 - 100,000', '101 - 100K', '100K - 10M', '10M - 100M', '>100m'];
		let dataBar = {
			labels: labels,
			borderWidth: 2,
			datasets: [
				{
					label: ' Accounts ',
					data: [var_100, var_100K, var_1M, var_10M, var_100M, var_100M_Plus],
					borderColor: "#ffffff",
					//backgroundColor: Utils.transparentize(Utils.CHART_COLORS.blue, 0),
					//hoverBackgroundColor: ['#4f81bd'],
					backgroundColor: context => { // Line background color to show two colors (P-2)
						const chart = context.chart;
						const { ctx, chartArea, scales } = chart;
						if (!chartArea) {
							return null;
						}
						return this.lineChartTwoColors(ctx, chartArea, scales);
					},
					borderWidth: 0,
					borderRadius: 1,
					borderSkipped: false,
				}
			]
		};
		this.dataBar = dataBar;

		let with_gold = dataAll.filter((obj: any) => (obj.balance / 10000) > 10000000 && obj.gold >= 1).length;
		let without_gold = dataAll.filter((obj: any) => (obj.balance / 10000) > 10000000 && (obj.gold == null || obj.gold <= 0)).length;
		let pie_labels = ['Without Gold Shibar', 'With Gold Shibar'];
		let dataPie = {
			labels: pie_labels,
			datasets: [{
				borderWidth: 0,
				borderRadius: 1,
				borderSkipped: false,
				label: ' Accounts ',
				data: [without_gold, with_gold],
				// backgroundColor: [
				// 	'#1b9ded',
				// 	'#f7225e'
				// ],
				backgroundColor: (context) => {
					const chart = context.chart;
					const { ctx, chartArea, scales } = chart;
					if (!chartArea) {
						return null;
					}
					if (context.dataIndex === 0) {
						return this.piechartGradientColor(chart);
					} else {
						return '#1b9ded';
					} 
				},
				//hoverBackgroundColor: [
				//	'#1b9ded',
				//	'#f7225e'
				//]
			}]
		};
		this.dataPie = dataPie;

		//Gauge Chart
		let dataGauge = {
			labels: pie_labels,
			datasets: [{
				borderWidth: 1,
				cutout: '95%',
				circumference: 180,
				rotation: 270,
				needleValue: 100,
				label: ' Accounts ',
				data: [without_gold, with_gold],
				backgroundColor: (context) => {
					const chart = context.chart;
					const { ctx, chartArea, scales } = chart;
					if (!chartArea) {
						return null;
					}
					if (context.dataIndex === 0) {
						return this.gaugeGradientColor(chart);
					} else {
						return '#ffffff';
					}
				},
				borderColor: (context) => {
					const chart = context.chart;
					const { ctx, chartArea, scales } = chart;
					if (!chartArea) {
						return null;
					}
					if (context.dataIndex === 0) {
						return this.gaugeGradientColor(chart);
					} else {
						return '#ffffff';
					}
				},
				// backgroundColor: [
				// 	this.gradientBg1,
				// 	'#f7225e'
				// ],
				// borderColor: [
				// 	this.gradientBg1,
				// 	'#f7225e'
				// ],
			}]
		};
		this.dataGauge = dataGauge;

		this.gaugeChartText = {
			id: 'gaugeChartText',
			afterDatasetDraw(chart, args, pluginOptions) {
				const { ctx,
					data,
					chartArea: { top, bottom, left, right, width, height, },
					scales: { r }
				} = chart;

				ctx.save();

				const needleValue = data.datasets[0].needleValue;
				const dataTotal = data.datasets[0].data.reduce((a, b) => a + b, 0);
				const angle = Math.PI + (1 / dataTotal * needleValue * Math.PI);
				const cx = width / 2;
				const cy = chart._metasets[0].data[0].y;

				//console.log("dataTotal: ", ctx.canvas.offsetTop);

				// Needle
				ctx.translate(cx, cy);

				ctx.rotate(angle);
				ctx.beginPath();
				ctx.moveTo(0, -2);
				ctx.lineTo(height - (ctx.canvas.offsetTop + 140), 0);
				ctx.lineTo(0, 2);
				ctx.fillStyle = "#fff";
				ctx.fill();

				//Needle dots
				ctx.translate(-cx, -cy);
				ctx.beginPath();
				ctx.arc(cx, cy, 5, 0, 10);
				ctx.fill();
				ctx.restore();

				const xCoor = chart.getDatasetMeta(0).data[0].x;
				const yCoor = chart.getDatasetMeta(0).data[0].y;
				const score = data.datasets[0].data[0];
				let rating;

				if (score == 0) {
					rating = 'Low';
				}
				if (score >= 61 && score <= 100) {
					rating = 'High';
				}
				if (score > 133) {
					rating = 'Very High';
				}

				ctx.font = '16px sans-serif';
				ctx.fillStyle = '#fff';
				ctx.textBaseLine = 'top';
				ctx.textAlign = 'left';

				// Left Value
				ctx.fillText('0', left, yCoor + 20);
				ctx.textAlign = 'right';

				// Right Value
				ctx.fillText('138', right, yCoor + 20);

				// Middle Value
				ctx.font = '30px sans-serif';
				ctx.textAlign = 'center';
				//ctx.textBaseLine = 'bottom';
				ctx.fillText(score, xCoor, yCoor + 40)

				// Rating Text - High, Low, Very High
				ctx.font = '16px sans-serif';
				ctx.textAlign = 'center';
				ctx.textBaseLine = 'bottom';
				ctx.fillText(rating, xCoor, yCoor + 60);
			}
		}
	}

	gaugeGradientColor(chart) {
		const { ctx, chartArea: { top, bottom, left, right } } = chart;
		const gaugeGradient = ctx.createLinearGradient(0, 0, right, 0);
		gaugeGradient.addColorStop(0, 'rgba(255, 0, 151, 1)');
		gaugeGradient.addColorStop(0.3, 'rgba(255, 95, 95, 1)');
		return gaugeGradient;
	}

	piechartGradientColor(chart) {
		const { ctx, chartArea: { top, bottom, left, right } } = chart;
		const gaugeGradient = ctx.createLinearGradient(0, 0, right, 0);
		gaugeGradient.addColorStop(0, 'rgba(255, 0, 151, 1)');
		gaugeGradient.addColorStop(1, 'rgba(255, 95, 95, 1)');
		return gaugeGradient;
	}

	// Line background color to show two colors (P-1)
	lineChartTwoColors(ctx, chartArea, scales) {
		//const gradientBg = ctx.createLinearGradient(chartArea.left, 0, chartArea.right, 0)
		const gradientBg = ctx.createLinearGradient(0, 0, 0, chartArea.bottom)
		//const percentage = ((scales.x.getPixelForTick(5) - chartArea.left) / chartArea.width);

		// Blue
		// gradientBg.addColorStop(1, 'rgba(0, 107, 172, 1)'); 
		// gradientBg.addColorStop(0.5, 'rgba(27, 157, 237, 1)');

		// First Gradient Combination
		gradientBg.addColorStop(1, 'rgba(255, 0, 151, 1)');
		gradientBg.addColorStop(0.5, 'rgba(255, 95, 95, 1)');

		// Second Gradient Combination
		// gradientBg.addColorStop(1, 'rgba(86, 3, 189, 1)'); 
		// gradientBg.addColorStop(0.5, 'rgba(255, 0, 151, 1)'); 
		return gradientBg;
	}

	private createBarChart(coinName) {
		this.chart = new Chart("DashboardBarChart", {
			type: 'bar',
			data: this.dataBar,
			options: {
				aspectRatio: 1,
				//maintainAspectRatio: false,
				responsive: true,
				scales: {
					y: {
						ticks: { color: '#8fe5ff' },
						grid: { color: 'rgba(255,255,255,0.3)' },
					},
					x: {
						ticks: { color: '#8fe5ff' },
						grid: { color: 'rgba(255,255,255,0.3)' },
					},

				},
				//layout: {
				//	padding: 30
				//},
				plugins: {
					legend: {
						position: 'bottom',
						labels: {
							padding: 15,
							color: "#ffffff"
						}
					},
					title: {
						display: true,
						color: "#ffffff",
						text: `$${coinName} Balance`,
						font: {
							size: 22
						},
						padding: {
							bottom: 20
						}
					},
					tooltip: {
						callbacks: {
							afterBody: function () {
								return "Click for more Details";
							}
						}
					}
				}
			},
		});
	}

	clickOnChartBar(click) {
		let var_100 = this.balances.filter((obj: any) => (obj.balance / 10000) < 101);
		let var_100K = this.balances.filter((obj: any) => (obj.balance / 10000) > 100 && (obj.balance / 10000) < 100001);
		let var_1M = this.balances.filter((obj: any) => (obj.balance / 10000) > 100000 && (obj.balance / 10000) < 1000001);
		let var_10M = this.balances.filter((obj: any) => (obj.balance / 10000) > 1000000 && (obj.balance / 10000) < 10000001);
		let var_100M = this.balances.filter((obj: any) => (obj.balance / 10000) > 10000000 && (obj.balance / 10000) < 100000001);
		let var_100M_Plus = this.balances.filter((obj: any) => (obj.balance / 10000) > 100000000);

		const barPoints = this.chart.getElementsAtEventForMode(click, 'nearest', {
			intersect: true
		}, true);

		if (barPoints[0]) {
			const datasetIndex = barPoints[0].datasetIndex;
			const clickedBarIndex = barPoints[0].index;
			this.clickBarChartLabel = this.chart.data.labels[clickedBarIndex];
			this.clickBarChartValue = this.chart.data.datasets[datasetIndex].data[clickedBarIndex];

			if (clickedBarIndex == 0) {

				this.clickBarChartAccount = var_100.map(x => { return { account: x.account, balance: x.balance } });
				this.paginationPage = 1;
				//console.log("This is First Column", var_100.map(x=>{return {account: x.account, balance: x.balance}}))

			} else if (clickedBarIndex == 1) {

				this.clickBarChartAccount = var_100K.map(x => { return { account: x.account, balance: x.balance } })
				this.paginationPage = 1;
				//console.log("This is Second Column", var_100K)

			} else if (clickedBarIndex == 2) {

				this.clickBarChartAccount = var_1M.map(x => { return { account: x.account, balance: x.balance } })
				this.paginationPage = 1;
				//console.log("This is Third Column", var_1M)

			} else if (clickedBarIndex == 3) {

				this.clickBarChartAccount = var_10M.map(x => { return { account: x.account, balance: x.balance } })
				this.paginationPage = 1;
				//console.log("This is Fourth Column", var_10M)

			} else if (clickedBarIndex == 4) {

				this.clickBarChartAccount = var_100M.map(x => { return { account: x.account, balance: x.balance } })
				this.paginationPage = 1;
				//console.log("This is Fifth Column", var_100M)

			} else if (clickedBarIndex == 5) {

				this.clickBarChartAccount = var_100M_Plus.map(x => { return { account: x.account, balance: x.balance } })
				this.paginationPage = 1;
				//console.log("This is Sixth Column", var_100M_Plus)

			} else { }
			this.sortBalance();
		}
	}

	private createPieChart() {
		this.piechart = new Chart("MyPieChart", {
			type: 'pie',
			data: this.dataPie,
			options: {
				//aspectRatio:1,
				responsive: true,
				//maintainAspectRatio: false,
				//layout: {
				//	padding: 30
				//},
				plugins: {
					legend: {
						position: 'bottom',
						labels: {
							padding: 15,
							color: "#ffffff"
						}
					},
					title: {
						display: true,
						color: "#ffffff",
						text: 'Accounts with More than 10M HSUITE',
						font: {
							size: 22
						},
						padding: {
							bottom: 20
						}
					},
					tooltip: {
						callbacks: {
							afterBody: function () {
								return "Click for more Details";
							}
						}
					}
				}
			},
		});
	}

	clickOnChartPie(click) {
		//console.log('DataAll', this.balances);
		let with_gold = this.balances.filter((obj: any) => (obj.balance / 10000) > 10000000 && obj.gold >= 1);
		let without_gold = this.balances.filter((obj: any) => (obj.balance / 10000) > 10000000 && (obj.gold == null || obj.gold <= 0));

		const piePoints = this.piechart.getElementsAtEventForMode(click, 'nearest', {
			intersect: true
		}, true);

		//console.log('DataPoints: ', barPoints);

		if (piePoints[0]) {
			const datasetIndex = piePoints[0].datasetIndex;
			const clickedBarIndex = piePoints[0].index;
			this.clickBarChartLabel = this.piechart.data.labels[clickedBarIndex];
			this.clickBarChartValue = this.piechart.data.datasets[datasetIndex].data[clickedBarIndex];

			if (clickedBarIndex == 0) {

				this.clickBarChartAccount = without_gold.map(x => { return { account: x.account, balance: x.balance } })
				this.paginationPage = 1;
				//console.log("Without Gold", without_gold.map(x=>{return {account: x.account, balance: x.balance}}))

			} else if (clickedBarIndex == 1) {

				this.clickBarChartAccount = with_gold.map(x => { return { account: x.account, balance: x.balance } })
				this.paginationPage = 1;
				//console.log("With Gold", with_gold)

			} else { this.sortBalance(); }

		}
	}

	private createGaugeChart() {
		this.gaugechart = new Chart("MyGaugeChart", {
			type: 'doughnut',
			data: this.dataGauge,
			options: {
				aspectRatio: 1.2,
				responsive: true,
				maintainAspectRatio: true,
				//layout: {
				//	padding: 30
				//},
				plugins: {
					legend: {
						display: false,
						position: 'bottom',
						labels: {
							padding: 15,
							color: "#ffffff"
						},
					},
					tooltip: {
						enabled: false
					},
					title: {
						display: true,
						color: "#ffffff",
						text: 'Gauge Chart',
						font: {
							size: 22
						},
						padding: {
							bottom: 20
						}
					},
				}
			},
			plugins: [this.gaugeChartText]
		});
	}

	onTableDataChange(event: any) {
		this.paginationPage = event;
	}

	sortBalance() {
		this.clickBarChartAccount.sort((a, b) => {
			if (this.isAscending) {
				return a.balance - b.balance;
			} else {
				return b.balance - a.balance;
			}
		});
		this.isAscending = !this.isAscending;
	}

	prepareView(){
		this.service.fetchData(this.token_id).then((result) => {
			this.balances = result['balances']
			this.updated = `Last Updated : ${result['date']}`
			this.initializedChartData(this.balances);
			this.createBarChart(this.coinName);
		})
	}

	handleChange(ev) {
		this.clickBarChartAccount = null;
		this.currentCoin = ev.target.value;
		this.token_id = this.currentCoin.value;
		this.coinName = this.currentCoin.name;
		this.chart.destroy();
		this.prepareView();
	}

	compareFn(item1: any, item2: any): boolean {
		return item1 && item2 ? item1.id === item2.id : item1 === item2;
	}

	ngOnInit(): void {
		this.service.fetchData('0.0.786931').then((result) => {
			//console.log("Result: ", result)
			this.balances = result['balances']
			this.updated = `Last Updated : ${result['date']}`
			this.spinner = false;
			this.initializedChartData(this.balances);
			this.createBarChart('Hsuite');
			this.createPieChart();
			//this.createGaugeChart();
		})
	}
	ngOnDestroy(): void {
		console.log("ngOnDestroy");
		// this.chart.clear()
		// this.chart.destroy();
		// this.piechart.destroy();

	}
}